import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import BubbleColumns from '../game/BubbleColumns';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import AquariumScreen from './AquariumScreen';
import CountFishScreen from './CountFishScreen';
import ResultScreen from './ResultScreen';
import TitleScreen from './TitleScreen';

let makingBubbles = true;
let bubbleColumns = null;

export function stopBubbles () {
  makingBubbles = false;
  bubbleColumns.visible = false;
}

export default class Background extends Phaser.Scene {
  static get KEY() { return 'Background'; }

  constructor() {
    super({ key: Background.KEY });
  }

  init() {
    this.scene.launch(TitleScreen.KEY);

    // this.scene.launch(CountFishScreen.KEY);

    // this.scene.launch(ResultScreen.KEY);
    // this.scene.launch(AquariumScreen.KEY);
  }

  create() {
    ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._Background, this).setOrigin(0);

    bubbleColumns = new BubbleColumns(this);
    this.add.existing(bubbleColumns);

    ABCyaPhaser.Images.addImage(0, this.scale.height, UIAssetKeys._BackgroundBottom, this).setOrigin(0, 1);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._background_bubbles, this, 1, true);
  }

  update(time, delta) {
    if (makingBubbles) bubbleColumns.tick(delta / 1000);
  }
}